import '../sass/project.scss';
import { init as initAttendance } from './components/attendance';
import { initBilling } from './components/billing';
import { initMarketingPricing } from './components/marketing_pricing';
import { init as initPasswordVisibility } from './components/password_visibility';
import { init as initPricing } from './components/pricing';
import { initQuotaUpgrade, showUpgradePrompt } from './components/quota_upgrade';
import { init as initSidebar } from './components/sidebar';
import { init as initSupport } from './components/support';
import { init as initTheme } from './components/theme';
import {
  initializeImagePreviews,
  initializeEmailRepeater,
  focusErrorSummary,
  initializeIncompleteSubmitDialog,
  initializeProgressBars,
  initializeRosterSearch,
  initializeTabList,
} from './components/ui_controls';

initSidebar();
initTheme();
initSupport();
initAttendance();
initPasswordVisibility();
initBilling();
initMarketingPricing();
initPricing();
initQuotaUpgrade();
initializeTabList();
initializeRosterSearch();
initializeEmailRepeater();
initializeIncompleteSubmitDialog();
initializeImagePreviews();
initializeProgressBars();
document.addEventListener('DOMContentLoaded', () => {
  focusErrorSummary();
});

window.showUpgradePrompt = showUpgradePrompt;
